import { FC } from 'react'
import { Markdown } from 'components/markdown'

import type { AboutServerSectionProps } from '../../types'

import Stats from './Stats'

type AboutProps = Pick<AboutServerSectionProps, 'description' | 'stats'>

const STATS = [
  {
    key: 'user_count',
    label: 'active users',
  },
  {
    key: 'group_count',
    label: 'active groups',
  },
  {
    key: 'post_count',
    label: 'posts a day',
  },
]

const About: FC<AboutProps> = ({ description, stats = {} }) => (
  <div>
    <Markdown markdown={description} className="text-base text-gray-900" />
    <div className="mt-xs flex gap-2.5">
      {STATS.map(({ key, label }) => (
        <Stats key={key} label={label} counter={stats?.[key] ?? 0} />
      ))}
    </div>
  </div>
)

export default About
